module.exports = __webpack_public_path__ + "img/meat.57c4cb47.png";